import React from "react";
import CommonAutocomplete from "../../../../../components/CommonAutocomplete";

function SelectInput({value, items, getId, getLabel, match, onSelect, ...prop}) {

  if (!getId) {
    getId = () => ""
  }

  if (!getLabel) {
    getLabel = () => ""
  }

  if (!match) {
    match = (item, inputValue) => {
      return getId(item).toString().includes(inputValue);
    }
  }

  const handleSelected = (e, item) => {
    onSelect(item ? getId(item) : null);
  }

  const selectedItem = items.find((item) => getId(item) === value);

  return (
    <div onBlur={(e) => handleSelected(e, selectedItem)}>
      <CommonAutocomplete
        name="selectInput"
        value={selectedItem}
        onSelect={handleSelected}
        data={items}
        filterOptions={(items, { inputValue }) => {
          return items.filter((item) => {
            return  item && inputValue ? match(item, inputValue): true;
          });
        }}
        optionLabel={(item) =>
          item ? getLabel(item) : ""
        }
        {...prop}
      />
    </div>
  );
}

export default React.memo(SelectInput);